(ns ui.view.card.fees.view
  (:require
   [common.localization :as loc]
   [frontend.view.entity :as entity-view]
   [frontend.view.modals.entity-editor.view :as entity-editor-modal]
   [frontend.view.modals.events :as modals]
   [re-frame.core :as rf]
   [ui.components.button.view :as button]
   [ui.view.card.entity-list.view :as entity-list-view]
   [ui.view.card.event :as common-event]
   [ui.view.card.fees.event :as event]
   [ui.view.card.fees.model :as model]
   [ui.view.card.fees.sub :as sub]
   [ui.view.card.shared-components.card-container :as card-container]
   [ui.view.card.shared-components.card-title :as card-title]
   [ui.view.card.shared-components.entity-peek :as entity-peek]
   [ui.view.card.shared-components.entity-table :as entity-table]
   [ui.view.card.shared-components.full-screen-card :as full-screen-card]

   ;; TODO: remove these once we have a new entity editor
   [ui.view.card.shared-components.view :as card-shared]
   [ui.view.card.sub :as common-sub]))

(defn add-new-fee-button
  [{:keys [entity-id preview-mode? primary-button? ctx] :as _props}]
  (let [component (if primary-button?
                    button/sm-primary-solid
                    button/sm-secondary-hollow)]
    [component
     {:disabled? preview-mode?
      :on-click  (fn []
                   (entity-view/open-creator!
                    :entity.type/fee
                    {:start-value   {:common/related-entities
                                     #{entity-id}}
                     :on-processed! (fn [{:keys [new-entity-id close-cb!]}]
                                      (rf/dispatch-sync [::event/refetch-data ctx])
                                      (close-cb!))}))}
     [:i {:class "fal fa-plus"}]
     (loc/tr :add-fee)]))

(defn empty-state-view
  [props]
  [:div
   {:class "flex flex-col items-center gap-4 py-5"}
   [:div
    {:class "relative"}
    [:i {:class "fal fa-comments-dollar text-5xl font-thin"}]
    [:div
     {:class "absolute -bottom-1 -right-2 flex items-center justify-center bg-base-light rounded-full w-7 h-7"}
     [:i {:class "fal fa-plus text-2xl"}]]]
   [:p
    {:class "text-lg font-semibold"}
    (loc/tr :no-fees-yet)]
   [:div
    {:class "flex justify-center"}
    [add-new-fee-button
     (assoc props :primary-button? true)]]])

(defn delete-fee-confirmation-modal
  [{:keys [ctx]}]
  (let [helper-text @(rf/subscribe [::sub/delete-fee-helper-text ctx])]
    [:dialog
     {:id    (model/delete-fee-confirmation-modal-id ctx)
      :class "border rounded p-0"}
     [:div
      {:class "relative p-3 flex flex-col gap-3 w-lg max-w-lg"}
      [:div
       {:class "absolute top-2 right-2"}
       [button/square-secondary-open
        {:on-click #(rf/dispatch [::event/close-delete-confirmation-modal ctx])}
        [:i {:class "fal fa-times"}]]]
      [:div
       {:class "flex justify-center mt-3"}
       [:i
        {:class "fal fa-exclamation-triangle text-2xl text-danger"}]]

      [:div
       [:h4
        {:class "text-center text-lg"}
        "Delete fee?"]
       [:p
        {:class "text-center text-base-light-text text-sm"}
        helper-text]]

      [:div
       {:class "flex justify-center gap-2"}
       [button/sm-secondary-hollow
        {:on-click #(rf/dispatch [::event/close-delete-confirmation-modal ctx])}
        "Cancel"]
       [button/sm-danger-solid
        {:on-click #(rf/dispatch [::event/delete-fee ctx])}
        "Delete"]]]]))

(defn table-view
  [{:keys [card ctx]}]
  (let [table-data @(rf/subscribe [::sub/table-data ctx])
        peek-entity-id @(rf/subscribe [::common-sub/entity-peek-entity-id ctx])]
    [:div
     {:class "flex flex-col gap-5 grow"}
     [entity-table/view
      {:config          (-> card :card/config :table)
       :data            table-data
       :selected-row-id peek-entity-id
       :on-row-clicked  (fn [{:keys [entity-id]}]
                          (rf/dispatch [::common-event/open-entity-peek-or-close-if-already-open ctx entity-id]))}]]))

(defn entity-peek-view
  [{:keys [card preview-mode? ctx]}]
  (let [open? @(rf/subscribe [::common-sub/entity-peek-open? ctx])
        peek-entity-id @(rf/subscribe [::common-sub/entity-peek-entity-id ctx])
        entity-peek-config (-> card :card/config :entity-peek)
        entity-peek-data @(rf/subscribe [::common-sub/entity-peek-data ctx entity-peek-config])]
    [entity-peek/view
     {:open?         open?
      :data          entity-peek-data
      :entity-type   :entity.type/fee
      :close         (fn []
                       (rf/dispatch [::common-event/close-entity-peek ctx]))
      :preview-mode? preview-mode?
      :edit          (fn []
                       (modals/open-modal!
                        entity-editor-modal/modal-key
                        {:entity-id         peek-entity-id
                         :skip-success-msg? true
                         :title-text        (loc/tr :edit-fee)
                         ;; FIXME: this is a workaround to refetch the data after the entity is edited
                         :on-cancel!        (fn []
                                              (rf/dispatch [::event/refetch-data ctx]))
                         :on-processed!     (fn [{:keys [new-entity-id close-cb!]}]
                                              (js/setTimeout (fn []
                                                               (close-cb!))
                                                             2000))}))
      :open-remove-confirmation
      (fn []
        (rf/dispatch [::event/open-delete-confirmation-modal ctx peek-entity-id]))}]))

(defn component
  [{:keys [card ctx] :as props}]
  (let [title (:card/title card)
        fees-count @(rf/subscribe [::sub/fees-count ctx])
        fees? (pos? fees-count)
        loading? @(rf/subscribe [::common-sub/loading? ctx])]
    [card-container/view
     {}
     [:div
      {:class "flex"}
      [:div
       {:class "flex flex-col gap-2 grow"}
       [:div
        {:class "flex justify-between min-h-12 items-start"}
        [card-title/view title]
        [:div
         {:class "flex gap-2 items-center"}
         (when fees?
           [add-new-fee-button props])
         [card-shared/expand-card props]]]
       (cond
         loading? [entity-list-view/loading-skeleton]
         fees? [table-view props]
         :else [empty-state-view props])]
      [entity-peek-view props]]]))

(defn full-screen-component
  [{:keys [ctx] :as props}]
  (let [fees-count @(rf/subscribe [::sub/fees-count ctx])
        loading? @(rf/subscribe [::common-sub/loading? ctx])]
    [full-screen-card/view
     props
     [:div
      {:class "flex w-full h-full"}
      (cond
        loading? [entity-list-view/loading-skeleton]
        (pos? fees-count) [table-view props]
        :else [empty-state-view props])
      [entity-peek-view props]]]))

(defn view
  [{:keys [full-screen?] :as props}]
  [:<>
   (if full-screen?
     [full-screen-component props]
     [component props])
   [delete-fee-confirmation-modal props]])
